export default "__VITE_ASSET__B2czSQdQ__"